module.exports = __webpack_public_path__ + "img/grazi_menu_3.dabe0888.png";